<template>
  <div class="user-container">
    <div class="avatar-info-container">
      <img :src="avatar" alt="加载失败...">
    </div>
    <div class="base-info-container">
      <div class="user-name-dept">
        <span class="user-name">{{name}}</span>
        <span class="user-dept">{{userInfo.dept}}</span>
      </div>
      <div class="user-id">
        <span>I D：</span><span>{{userInfo.id}}</span>
      </div>
      <div class="user-email">
        <span>邮箱：</span><span>{{userInfo.email}}</span>
      </div>
      <div class="user-mobile">
        <span>手机：</span> <span>{{userInfo.mobile}}</span>
      </div>
      <div class="user-role">
        <span>角色：</span> <span>{{userInfo.isAdmin?'管理员':'普通用户'}}</span>
      </div>
    </div>
    <div class="user-container-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['name', 'avatar', 'userInfo'])
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.user-container {
  display: flex;
  flex-flow: row wrap;
  .avatar-info-container {
    flex: 1;
    text-align: center;
    > img {
      width: 100px;
      height: 100px;
      border-radius: 20%;
    }
  }
  .base-info-container {
    display: flex;
    flex: 3;
    flex-wrap: wrap;
    padding-left: 5px;
    font-size: 16px;
    color: #718096;
    .user-name-dept {
      width: 100%;
      .user-name {
        font-size: 18px;
        color: #333;
        font-weight: 700;
      }
      .user-dept {
        margin-left: 12px;
      }
    }

    .user-email,
    .user-mobile,
    .user-id,
    .user-role {
      width: 50%;
      > span:first-child {
        display: inline-block;
        min-width: 50px;
        height: 32px;
        line-height: 32px;
        text-align: right;
      }
      > span:last-child {
        flex: 6;
      }
    }
  }
  &-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    width: 100%;
  }
}
</style>